import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'welcome-to-the-planner',
  standalone: true,
  imports: [],
  templateUrl: './welcome-to-the-planner.component.html',
  styleUrl: './welcome-to-the-planner.component.scss',
})
export class WelcomeToThePlannerComponent {
  @Output() addTag = new EventEmitter<void>();
}
